import { Theme } from '@mui/material/styles';

export const styles = {
  primary: (theme: Theme) => ({
    width: '100%',
    padding: '8px',
    borderRadius: '4px',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    background: theme.palette.common.action['normal 2'],
  }),
  outlined: (theme: Theme) => ({
    width: '100%',
    padding: '12px 24px',
    borderRadius: '24px',
    minHeight: '48px',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    background: theme.palette.common.surface['surface 1'],
    border: `1px solid ${theme.palette.divider}`,
  }),
  ratioSelected: (theme: Theme) => ({
    border: `1px solid ${theme.palette.common.dividerBrand}`,
  }),
};
